import type {AppState} from '../reducer';
import {IElement} from '../../incase-domain/elements';

export const clipboardDataSelector = (state: AppState): IElement | null => state.clipboardReducer.data;

export const hasValidClipboardDataSelector = (state: AppState): boolean => state.clipboardReducer.hasValidData;
